import * as React from "react";
import { useSearchParam } from "@linkfluence/core/router/param";
import InsightPageConnectedPage from "./insight-page";
import ProjectConnectedPage from "./project";
import { useCurrentProjectAndWorkspaceFromParams } from "./use-cases";
import WorkspaceConnectedPage from "./workspace";

type InputParams = { projectId: number; workspaceId: number };

export default function ConnectedPage({
  children,
  onAccessError,
  onLoading,
  params: inputParams,
}: {
  children: React.ReactNode;
  onAccessError: () => React.ReactNode;
  onLoading: () => React.ReactNode;
  params?: Partial<InputParams>;
}) {
  const { projectId, workspaceId } =
    useCurrentProjectAndWorkspaceFromParams(inputParams);

  const { param: pageId } = useSearchParam("page", "");
  if (projectId) {
    if (workspaceId) {
      return (
        <ProjectConnectedPage
          id={projectId}
          onAccessError={onAccessError}
          onLoading={onLoading}
        >
          <WorkspaceConnectedPage
            id={workspaceId}
            onAccessError={onAccessError}
            onLoading={onLoading}
          >
            <InsightPageConnectedPage id={pageId}>
              {children}
            </InsightPageConnectedPage>
          </WorkspaceConnectedPage>
        </ProjectConnectedPage>
      );
    } else {
      return (
        <ProjectConnectedPage
          id={projectId}
          onAccessError={onAccessError}
          onLoading={onLoading}
        >
          <InsightPageConnectedPage id={pageId}>
            {children}
          </InsightPageConnectedPage>
        </ProjectConnectedPage>
      );
    }
  } else {
    return <>{children}</>;
  }
}
